import { QcPlanReloadFlag } from '../../../contracts/qc-plan/qc-plan-detail.model';

export interface IQcPlanFlagState {
    qcPlanFlag: QcPlanReloadFlag;
}

const initialState: IQcPlanFlagState = {
    qcPlanFlag: {
        'DoNotReloadList': '0'
    }
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/qc-plan/IQcPlanFlagState.ts